import { BRANDS } from "../data/content";

export const BrandsMarquee = () => {
  const items = [...BRANDS, ...BRANDS, ...BRANDS];
  return (
    <div data-testid="brands-marquee" className="bg-[#FAFAFA] border-y border-black/5 py-10 overflow-hidden">
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {items.map((brand, i) => (
              <span key={`${copy}-${i}`} className="flex items-center px-12 shrink-0">
                <img
                  src={brand.logo}
                  alt={`${brand.name}, marca profissional parceira INN.PACT`}
                  className="h-9 md:h-11 w-auto object-contain brand-logo"
                  loading="lazy"
                  decoding="async"
                  draggable="false"
                />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
